<template>
  <v-card dark>
    <div v-for="assessment in application.psychometrics" :key="`assessment-${assessment.id}`">
      <v-list dense v-if="assessment.show || assessment.provider != 'Odyssey' || assessment.aggregate >= 2">
        <v-list-tile v-if="assessment.title || assessment.aggregate">
          <v-list-tile-content v-html="assessment.title || 'Aggregate'" class="title" />
          <v-list-tile-action v-if="assessment.aggregate && assessment.provider != 'Odyssey'">
            {{ assessment.aggregate }}
          </v-list-tile-action>
        </v-list-tile>
        <v-list-tile v-if="assessment.provider != 'Odyssey'" v-for="(value, descriptor) in assessment.values" :key="`assessment-value-${descriptor}`">
          <v-list-tile-content v-html="descriptor" />
          <v-list-tile-action>
            <v-list-tile-action-text>{{ value }}</v-list-tile-action-text>
          </v-list-tile-action>
        </v-list-tile>
        <v-list-tile v-if="assessment.provider == 'Odyssey'">
          <v-list-tile-content v-if="assessment.aggregate === 4" class="green--text text--darken-1">Excellent Fit</v-list-tile-content>
          <v-list-tile-content v-if="assessment.aggregate === 3" class="light-green--text text--darken-1">Strong Fit</v-list-tile-content>
          <v-list-tile-content v-if="assessment.aggregate === 2" class="lime--text text--darken-1">Moderate Fit</v-list-tile-content>
          <v-list-tile-content v-if="assessment.aggregate === 1" class="orange--text">Weak Fit</v-list-tile-content>
          <v-list-tile-content v-if="assessment.aggregate === 0" class="red--text">No Fit</v-list-tile-content>
        </v-list-tile>
        <v-list-tile v-if="assessment.provider == 'Odyssey'" v-for="(value, descriptor) in assessment.values" :key="`assessment-value-${descriptor}`">
          <v-list-tile-content v-html="descriptor" />
          <v-list-tile-action>
            <v-list-tile-action-text>{{ value }}</v-list-tile-action-text>
          </v-list-tile-action>
        </v-list-tile>
      </v-list>
    </div>
  </v-card>
</template>

<script>
// Helpers
import _ from 'lodash'

export default {
  props: { application: Object },
}
</script>
